// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const DealerTransferHistory = t.struct({
    approvalDealerComments: t.maybe(t.String),
    changedBy: t.maybe(t.String),
    changedOn: t.maybe(t.Number),
    currentDealer: t.maybe(t.String),
    currentDealerName: t.maybe(t.String),
    customer: t.maybe(t.String),
    deereRemarks: t.maybe(t.String),
    newDealer: t.maybe(t.String),
    newDealerName: t.maybe(t.String),
    pin: t.maybe(t.String),
    reasonForChange: t.maybe(t.String),
    requestDate: t.maybe(t.Number),
    requestedBy: t.maybe(t.String),
    statusIndicator: t.maybe(t.String)
}, {
    name: 'DealerTransferHistory',
    strict: true
});

export const getDefaultState = () => new DealerTransferHistory({});

export default DealerTransferHistory;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-transfer-history.js